import { useWindowSize } from '@vueuse/core';
import { watch } from 'vue';

export const useResizeScale = () => {
  const defaultFontSize = 16;
  const designWidth = 1440;
  const designHeight = 780;
  const defaultWidth = 2000;
  const defaultMaxWidth = 9999;
  const defaultMinWidth = 1480;
  const { width, height } = useWindowSize();
  watch(
    () => [width.value, height.value],
    ([val, valHeight]) => {
      if (val > defaultMinWidth && val < defaultMaxWidth) {
        document.documentElement.style.setProperty('--ratio', '1');
        document.documentElement.style.setProperty('--offset', '0');
        document.documentElement.style.setProperty('--offset-trans', '0');
        document.documentElement.classList.remove('scale');
        let fontSize = Math.floor(
          Math.min(val / designWidth, valHeight / designHeight) * defaultFontSize,
        );
        fontSize = fontSize < 12 ? 12 : fontSize;
        fontSize = fontSize > 20 ? 20 : fontSize;
        document.documentElement.style.fontSize = fontSize + 'px';
        return;
      }
      document.documentElement.style.setProperty('--ratio', '1');
      document.documentElement.style.setProperty('--offset', '0');
      document.documentElement.style.setProperty('--offset-trans', '0');
      if (val > 1280 || valHeight > 780) {
        document.documentElement.style.fontSize = defaultFontSize + 'px';
      } else {
        let fontSize = Math.ceil(Math.min(val / 80, valHeight / 48.75));
        fontSize = fontSize < 12 ? 12 : fontSize;
        document.documentElement.style.fontSize = fontSize + 'px';
      }
      return;
      // 除数
      const divisor = val > defaultWidth ? defaultWidth : defaultMinWidth;
      // 4舍5入
      let ratio = Math.round(val / divisor);
      if (ratio < 1) {
        ratio = 1;
      }
      if (ratio > 5) {
        ratio = 5;
      }
      const scale = Number(((1 / ratio) * 100).toFixed(0));
      const offsetTranslate = scale - 100 + '%';
      const offset = 100 - scale + '%';
      document.documentElement.style.setProperty('--ratio', `${ratio}`);
      document.documentElement.style.setProperty('--offset', offset);
      document.documentElement.style.setProperty('--offset-trans', offsetTranslate);
      // 根元素添加class
      document.documentElement.classList.add('scale');
    },
    {
      immediate: true,
    },
  );

  /**
   * 屏幕大小变化时，重新加载页面
   */
  // const handleResize = () => {
  //   location.reload();
  // };

  // onMounted(() => {
  //   window.addEventListener('resize', handleResize);
  // });

  // onUnmounted(() => {
  //   window.removeEventListener('resize', handleResize);
  // });
};
